module.exports = __webpack_public_path__ + "static/brands-mobile-954b4075d993fc3a6d7b50ae3627a9d2.png";